import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';

export default function AGalleryButton({
	type,
	onClick,
}) {
	let bType;

	switch (type) {
		case 'left':
			bType = 'arrowLeft';
			break;
		case 'right':
			bType = 'arrowRight';
			break;
		default:
			break;
	}

	return (
		<button className="a-button-gallery" onClick={onClick}>
			<AIcon type={bType} className="a-button-gallery--icon" />
		</button>
	);
}

AGalleryButton.propTypes = {
	type: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.gallery-button.js